export const cryptPayoutSystems = ['bitcoin', 'doge', 'eth', 'ethereum'];
